import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import axios from "axios";
import { Button, Dialog, DialogContent, DialogTitle, Box } from "@mui/material";
import AddLieferant from "./AddLieferant";
import { getToken, base_url } from "../../config/config";

const LieferantTable = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios
      .get(`${base_url}/v1/getLieferant`)
      .then((response) => {
        if (response.data && response.data.data) {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const columns = [
    { accessorKey: "konto", header: "Konto" },
    { accessorKey: "bezeichnung", header: "Bezeichnung" },
    { accessorKey: "kurzbezeichnung", header: "Kurzbezeichnung" },
    { accessorKey: "ustIdNummer", header: "USt-IdNr" },
    // { accessorKey: "address", header: "Adresse" },
    {
      accessorKey: "plz",
      header: "PLZ",
      accessorFn: (row) => row.address?.[0]?.plz || "",
    },
    {
      accessorKey: "ort",
      header: "Ort",
      accessorFn: (row) => row.address?.[0]?.Ort || "",
    },
    {
      accessorKey: "strasse",
      header: "Straße",
      accessorFn: (row) => row.address?.[0]?.strasse || "",
    },
  ];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh", p: 3 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        style={{ marginBottom: "20px" }}
      >
        Add New Lieferant
      </Button>

      <MaterialReactTable
        columns={columns}
        data={data}
        enableRowSelection={false}
        enableSorting={true}
        initialState={{ showColumnFilters: true }}
      />

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Add New Lieferant</DialogTitle>
        <DialogContent>
          <AddLieferant />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default LieferantTable;
